declare var BASE_URL:string;

import '../styles/footer.scss';

import { h, Component } from 'preact';

export default function footer (props) {

    return <footer>
      <div class="mainWrp">
        <div>
          <nav>
            <ul>
              <li>
                <a href="privacy">Privacy Policy</a>
              </li><li>
              <a href="terms">Terms and Conditions</a>
            </li><li>
              <a href={ BASE_URL + 'contacts' }>Contacts</a>
            </li>
            </ul>
          </nav>
          <p>© Querlo LLC 2020 all rights reserved</p>
        </div>

        <ul class="socials">
          <li>
            <a href="https://www.linkedin.com/company/querlo/" target="_blank"><i class="fab fa-linkedin"></i></a>
          </li><li>
            <a href="https://www.youtube.com/channel/UCpr2xRv5W2AAmNTpteaPKGg/videos" target="_blank"><i class="fab fa-youtube"></i></a>
          </li><li>
            <a href="https://www.facebook.com/QuerloPanel/" target="_blank"><i class="fab fa-facebook-square"></i></a>
          </li>
        </ul>
      </div>
    </footer>;

};


// WEBPACK FOOTER //
// ./ts/footer.tsx